import { observer } from 'mobx-react';

import { useFlag } from '../../../../services/launchDarkly';
import PromoCodeInputDialogOld from '../PromoCodeInputDialog/PromoCodeInputDialog';

import PromoCodeInputDialog from './PromoCodeInputDialog';

export const PromoCodeController = observer(() => {
  const useRedesignedLounge = useFlag('ui_redesign_lounge', false);
  const useRedesignedDialogs = useFlag('ui_redesign_dialogs', false);

  if (useRedesignedLounge && useRedesignedDialogs) {
    return <PromoCodeInputDialog />;
  }

  return <PromoCodeInputDialogOld />;
});
